import { httpRequest } from "@services/http";
import { bannersUrl, type Banner } from "./cmdListBanners";

export class CommandGetBanner {
  async run(uuid: string): Promise<Banner> {
    try {
      return await httpRequest<Banner>(`${bannersUrl()}${uuid}/`, { method: "GET" });
    } catch (error) {
      console.error("Error fetching banner:", error);
      throw error;
    }
  }
}
